import { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const dropdownImages: Record<string, string> = {
  'cat-shoes-01': 'https://readdy.ai/api/search-image?query=Single%20white%20running%20sneaker%20on%20light%20concrete%20studio%20surface%2C%20diffused%20natural%20window%20light%2C%20clean%20minimalist%20product%20photography%2C%20subtle%20cool%20grey%20shadows%2C%20crisp%20textile%20texture%2C%20modern%20athletic%20aesthetic&width=80&height=80&seq=nav-shoes&orientation=squarish',
  'cat-hoodies-02': 'https://readdy.ai/api/search-image?query=Forest%20green%20cotton%20hoodie%20folded%20neatly%20on%20raw%20oak%20wood%20surface%2C%20warm%20morning%20sunlight%20from%20side%20window%2C%20lifestyle%20product%20photography%2C%20visible%20fabric%20weave%20texture%2C%20cozy%20autumn%20vibe&width=80&height=80&seq=nav-hoodies&orientation=squarish',
  'cat-tshirts-03': 'https://readdy.ai/api/search-image?query=Plain%20white%20heavyweight%20cotton%20tshirt%20draped%20on%20linen%20fabric%20surface%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20clean%20minimal%20composition%2C%20subtle%20fabric%20fold%20shadows&width=80&height=80&seq=nav-tshirts&orientation=squarish',
  'cat-jackets-04': 'https://readdy.ai/api/search-image?query=Olive%20green%20bomber%20jacket%20laid%20flat%20on%20dark%20slate%20stone%20surface%2C%20dramatic%20side%20lighting%2C%20fashion%20editorial%20product%20shot%2C%20visible%20stitching%20and%20hardware%20details%2C%20premium%20quality%20textile&width=80&height=80&seq=nav-jackets&orientation=squarish',
  'cat-pants-05': 'https://readdy.ai/api/search-image?query=Beige%20chino%20pants%20folded%20neatly%20on%20natural%20jute%20rug%20texture%2C%20warm%20afternoon%20light%2C%20relaxed%20lifestyle%20product%20photography%2C%20soft%20earth%20tone%20palette%2C%20casual%20wear%20aesthetic&width=80&height=80&seq=nav-pants&orientation=squarish',
  'cat-headwear-06': 'https://readdy.ai/api/search-image?query=Black%20baseball%20cap%20with%20curved%20brim%20on%20textured%20white%20paper%20background%2C%20clean%20overhead%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20sharp%20shadow%20definition%2C%20streetwear%20style&width=80&height=80&seq=nav-headwear&orientation=squarish',
  'cat-sets-07': 'https://readdy.ai/api/search-image?query=Coordinated%20two%20piece%20sweatsuit%20set%20in%20charcoal%20grey%20arranged%20on%20pale%20marble%20surface%2C%20soft%20even%20studio%20lighting%2C%20premium%20product%20photography%2C%20clean%20symmetrical%20composition%2C%20luxury%20athleisure&width=80&height=80&seq=nav-sets&orientation=squarish',
  'cat-underwear-08': 'https://readdy.ai/api/search-image?query=Soft%20cotton%20boxer%20briefs%20rolled%20neatly%20on%20smooth%20bamboo%20wood%20surface%2C%20gentle%20diffused%20lighting%2C%20clean%20product%20photography%2C%20minimalist%20aesthetic%2C%20natural%20fabric%20texture&width=80&height=80&seq=nav-underwear&orientation=squarish',
  'cat-jersey-09': 'https://readdy.ai/api/search-image?query=Bright%20red%20basketball%20jersey%20with%20white%20number%20detail%20spread%20on%20light%20grey%20concrete%20floor%2C%20sharp%20angular%20lighting%2C%20sports%20product%20photography%2C%20dynamic%20presentation%2C%20athletic%20gear&width=80&height=80&seq=nav-jersey&orientation=squarish',
  'cat-accessories-10': 'https://readdy.ai/api/search-image?query=Silver%20stainless%20steel%20watch%20and%20leather%20bracelet%20arranged%20on%20dark%20slate%20tile%2C%20dramatic%20spotlight%20lighting%2C%20luxury%20accessories%20product%20photography%2C%20elegant%20composition%2C%20metallic%20reflections&width=80&height=80&seq=nav-accessories&orientation=squarish',
  'cat-bags-11': 'https://readdy.ai/api/search-image?query=Tan%20leather%20crossbody%20bag%20standing%20upright%20on%20light%20birch%20wood%20surface%2C%20natural%20morning%20light%2C%20lifestyle%20product%20photography%2C%20visible%20leather%20grain%20texture%2C%20modern%20minimalist%20design&width=80&height=80&seq=nav-bags&orientation=squarish',
  'cat-belts-12': 'https://readdy.ai/api/search-image?query=Brown%20genuine%20leather%20belt%20coiled%20neatly%20on%20dark%20walnut%20wood%20surface%2C%20soft%20golden%20hour%20light%20from%20window%2C%20premium%20product%20photography%2C%20rich%20leather%20texture%20visible%2C%20classic%20accessory&width=80&height=80&seq=nav-belts&orientation=squarish',
  'cat-perfumes-13': 'https://readdy.ai/api/search-image?query=Amber%20glass%20perfume%20bottle%20with%20minimalist%20label%20on%20white%20marble%20surface%2C%20soft%20diffused%20studio%20lighting%2C%20luxury%20fragrance%20product%20photography%2C%20elegant%20composition%2C%20subtle%20reflection&width=80&height=80&seq=nav-perfumes&orientation=squarish',
  'cat-other-14': 'https://readdy.ai/api/search-image?query=Assorted%20fashion%20accessories%20sunglasses%20scarf%20and%20small%20leather%20goods%20arranged%20on%20light%20linen%20fabric%2C%20soft%20natural%20lighting%2C%20curated%20product%20photography%2C%20editorial%20styling%2C%20warm%20neutral%20palette&width=80&height=80&seq=nav-other&orientation=squarish',
};

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setMobileCatOpen(false);
    setDropdownOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      id="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`flex items-center gap-2 text-lg md:text-xl font-heading font-bold whitespace-nowrap transition-colors duration-300 ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-white drop-shadow-sm'
            }`}
          >
            ACBuySpreadsheet
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-semibold whitespace-nowrap transition-colors duration-300 ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
              }`}
            >
              Home
            </Link>

            <a
              href="#categories"
              className={`text-sm font-semibold whitespace-nowrap transition-colors duration-300 ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
              }`}
            >
              Shopping Guide
            </a>

            <Link
              to="/article/what-is-acbuyspreadsheet"
              className={`text-sm font-semibold whitespace-nowrap transition-colors duration-300 ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
              }`}
            >
              SEO Guides
            </Link>

            <div ref={dropdownRef} className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className={`flex items-center gap-1 text-sm font-semibold whitespace-nowrap transition-colors duration-300 ${
                  scrolled || !isHome ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/90 hover:text-white'
                }`}
              >
                Shop Categories
                <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </span>
              </button>

              {dropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-background-50 rounded-lg py-2 max-h-[70vh] overflow-y-auto border border-background-200">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors"
                    >
                      <div className="w-9 h-9 rounded-md overflow-hidden flex-shrink-0">
                        <img
                          src={dropdownImages[cat.imageSeq]}
                          alt={cat.name}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <span className="whitespace-nowrap">{cat.name}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className={`px-5 py-2 rounded-md text-sm font-semibold whitespace-nowrap transition-all duration-300 ${
                scrolled || !isHome
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 backdrop-blur-sm text-white border border-white/30 hover:bg-white/30'
              }`}
            >
              Buy It Now
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center transition-colors duration-300 ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 px-4 max-h-[80vh] overflow-y-auto">
            <div className="flex flex-col gap-1">
              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 rounded-md text-sm font-semibold text-foreground-800 hover:bg-background-100 transition-colors"
              >
                <span className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-md">
                  <i className="ri-home-4-line text-accent-700"></i>
                </span>
                Home
              </Link>

              <a
                href="#categories"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 rounded-md text-sm font-semibold text-foreground-800 hover:bg-background-100 transition-colors"
              >
                <span className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-md">
                  <i className="ri-shopping-bag-3-line text-primary-700"></i>
                </span>
                Shopping Guide
              </a>

              <Link
                to="/article/what-is-acbuyspreadsheet"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-3 py-3 rounded-md text-sm font-semibold text-foreground-800 hover:bg-background-100 transition-colors"
              >
                <span className="w-8 h-8 flex items-center justify-center bg-secondary-100 rounded-md">
                  <i className="ri-article-line text-secondary-700"></i>
                </span>
                SEO Guides
              </Link>

              <button
                onClick={() => setMobileCatOpen(!mobileCatOpen)}
                className="flex items-center justify-between w-full px-3 py-3 rounded-md text-sm font-semibold text-foreground-800 hover:bg-background-100 transition-colors"
              >
                <span className="flex items-center gap-3">
                  <span className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-md">
                    <i className="ri-grid-line text-accent-700"></i>
                  </span>
                  Shop Categories
                </span>
                <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${mobileCatOpen ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>

              {mobileCatOpen && (
                <div className="ml-4 border-l-2 border-background-200 pl-4 mt-1 mb-2">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 py-2.5 px-2 text-sm text-foreground-600 hover:text-foreground-900 transition-colors rounded-md hover:bg-background-100"
                    >
                      <div className="w-10 h-10 rounded-md overflow-hidden flex-shrink-0">
                        <img
                          src={dropdownImages[cat.imageSeq]}
                          alt={cat.name}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <span>{cat.name}</span>
                    </a>
                  ))}
                </div>
              )}

              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileMenuOpen(false)}
                className="mt-3 mx-3 px-5 py-3 bg-primary-500 text-white rounded-md text-sm font-semibold hover:bg-primary-600 transition-colors text-center"
              >
                Buy It Now
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}